module.exports = __webpack_public_path__ + "img/erweima.e4598c3c.jpg";